import type { RouteRecord } from 'vite-react-ssg'
import Home from './pages/Home'
import Articles from './pages/Articles'
import ArticleDetail from './pages/ArticleDetail'
import AuthorDetail from './pages/AuthorDetail'
import Disclaimer from './pages/Disclaimer'
import NotFound from './pages/NotFound'
import { articles, featuredArticle } from './data/articles'
import { authors } from './data/authors'

const articleSlugs = [featuredArticle, ...articles].map((a) => a.slug)
const authorSlugs = authors.map((a) => a.slug)

export const routes: RouteRecord[] = [
  { path: '/', element: <Home /> },
  { path: '/articles', element: <Articles /> },
  {
    path: '/articles/:slug',
    element: <ArticleDetail />,
    getStaticPaths: () => articleSlugs.map((slug) => `articles/${slug}`),
  },
  {
    path: '/authors/:slug',
    element: <AuthorDetail />,
    getStaticPaths: () => authorSlugs.map((slug) => `authors/${slug}`),
  },
  { path: '/disclaimer', element: <Disclaimer /> },
  // Prerenders to dist/404.html, which nginx serves via `error_page 404 /404.html`.
  { path: '/404', element: <NotFound /> },
  // Client-side catch-all, so an in-app navigation to a dead route renders the
  // same page instead of a blank shell. Not prerendered (no getStaticPaths).
  { path: '*', element: <NotFound /> },
]
